import { Typography } from "@material-ui/core"
import { Regulation } from "api"
import { useIsDesktop } from "common/MediaQueries"
import styled from "styled-components"
import pollutionColors from "./pollutionColors"

const StyledCaption = styled(Typography).attrs({ variant: "caption" })`
  display: inline-block;
  margin-top: 10px;
`

const StyledCellDiv = styled.div`
  margin-top: 30px;
  width: 95%;
  table {
    width: 100%;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    margin-top: 20px;
  }
  th,
  td {
    border: 1px solid ${(p) => p.theme.colors.darkGrey};
    padding: 5px;
    font-size: 11px;
  }
`

const StyledTable = styled.table`
  border-spacing: 0px;
  text-align: center;
  color: ${(p) => p.theme.colors.disable};
  thead {
    background: ${(p) => p.theme.colors.borderGrey};
    color: ${(p) => p.theme.colors.black};
  }
`

const StyledTh = styled.th<{ $minWidth?: number }>`
  ${(p) => p.$minWidth && `min-width: ${p.$minWidth}px`};
  font-size: 11px;
  font-weight: 400;
`

type PollutionTableProps = {
  data: Regulation
}

const PollutionTable = ({ data }: PollutionTableProps) => {
  const isDesktop = useIsDesktop()
  return (
    <StyledCellDiv>
      <StyledTable>
        <thead>
          <tr>
            <StyledTh colSpan={1} scope="colgroup">
              דגם
            </StyledTh>
            <StyledTh colSpan={2} scope="colgroup" $minWidth={isDesktop && 220}>
              צריכת דלק בליטרים ל100 ק״מ*
            </StyledTh>
            <StyledTh colSpan={1} scope="colgroup">
              דרגת זיהום
            </StyledTh>
          </tr>
        </thead>
        <tbody>
          {data?.pollutionTable.map((item, i) => (
            <tr key={i}>
              <td>{item?.finishingLevelFullName}</td>
              <td>{item.fuelConsuption}</td>
              <td>{item.consuptionType}</td>
              <td
                style={{
                  background: pollutionColors[item.pullotionLevel - 1],
                  color: "#FFFFFF",
                }}
              >
                {item.pullotionLevel}
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>

      <StyledCaption>{data.pollutionComment}</StyledCaption>
    </StyledCellDiv>
  )
}

export default PollutionTable
